import { Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import MultiFillSlider, { FillValues } from '~/components/MultiFillSlider'
import { CallTranscript } from '~/types/CallTranscript'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

interface OfficeSentimentSliderWrapperProps {
  $margin?: string
}
const OfficeSentimentSliderWrapper = styled.div<OfficeSentimentSliderWrapperProps>`
  display: flex;
  flex-direction: column;
  margin: ${(props) => props.$margin ?? 'none'};
`

interface SentimentSliderProps {
  callTranscript: CallTranscript
  participantRole: 'AGENT' | 'CUSTOMER'
  margin?: string
}

export const SentimentSlider = ({
  callTranscript,
  margin,
  participantRole,
}: SentimentSliderProps) => {
  const { t } = useTranslation()

  const getSentimentColor = (sentiment: string) => {
    switch (sentiment) {
      case 'POSITIVE':
        return 'var(--chakra-colors-green-solid)'
      case 'NEGATIVE':
        return 'var(--chakra-colors-red-solid)'
      default:
        return 'var(--chakra-colors-fg-muted)'
    }
  }

  const getSentimentTooltipText = (sentiment: string) => {
    switch (sentiment) {
      case 'POSITIVE':
        return t('callFilters.sentiment.positive')
      case 'NEGATIVE':
        return t('callFilters.sentiment.negative')
      case 'NEUTRAL':
        return t('callFilters.sentiment.neutral')
      default:
        return t('callFilters.sentiment.neutral')
    }
  }

  const sentimentEntry =
    callTranscript.Transcript.filter((t) => {
      return t.ParticipantRole === participantRole
    }).map((transcriptEntry) => {
      const callDuration =
        callTranscript.ConversationCharacteristics
          .TotalConversationDurationMillis
      return {
        startPercentage: transcriptEntry.BeginOffsetMillis / callDuration,
        endPercentage: transcriptEntry.EndOffsetMillis / callDuration,
        fillProps: {
          fillColor: getSentimentColor(transcriptEntry.Sentiment),
          fillHeight: 6,
          fillBorderRadius: 0,
        },
        tooltipText: getSentimentTooltipText(transcriptEntry.Sentiment),
      } as FillValues
    }) ?? []

  return (
    <OfficeSentimentSliderWrapper $margin={margin}>
      <Text
        {...textStyles[textStyleKeys.body3]}
        fontSize="12px"
        color="fg.muted"
      >
        {participantRole === 'AGENT'
          ? t('callDetails.sections.sentimentByQuarter.office')
          : t('callDetails.sections.sentimentByQuarter.patient')}
      </Text>
      <MultiFillSlider
        height={6}
        backgroundColor="var(--chakra-colors-border-subtle)"
        width="100%"
        animate
        fillValues={sentimentEntry}
      />
    </OfficeSentimentSliderWrapper>
  )
}
